import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
import './i18nextInit';
import TagManager from 'react-gtm-module';

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({ site: 'border360' });

if (
    !Capacitor.isNativePlatform() &&
    import.meta.env.VITE_DISABLE_ANALYTICS !== 'true'
) {
    TagManager.initialize({ gtmId: 'GTM-NHQ878G8' });
}

// Catch Vite chunk load failures after deploy; guard prevents infinite reload loop
let preloadReloading = false;
window.addEventListener('vite:preloadError', () => {
    if (preloadReloading) return;
    preloadReloading = true;
    window.location.reload();
});

async function bootstrap() {
    // On native, restore auth from the durable Keychain/Keystore-backed store
    // BEFORE the auth slice reads its initial state. Wrapped so a native failure
    // can never block rendering the app.
    if (Capacitor.isNativePlatform()) {
        try {
            const { hydrateAuthFromNative } = await import('./utils/nativeStorage');
            await hydrateAuthFromNative();
            // Fire-and-forget native UI init (viewport, status bar, back button,
            // splash). Non-blocking so a native failure can't delay render.
            import('./native')
                .then(({ initNative }) => initNative())
                .catch((err) => console.error('initNative failed:', err));
        } catch (e) {
            console.error('Native auth hydration failed, continuing:', e);
        }
    }

    // Import App after native hydration so the auth slice reads restored values.
    const { default: App } = await import('./App');
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
}

bootstrap();
